/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import useBrowserUUID from '../../app/helpers/useBrowserUUID';

const browserUUID = useBrowserUUID();

export const fetchUserEmailbyBrowserUUID = async () => {
    const token = await getAccessTokenSafely();
    const wcEnv = { rootUri: '/' };
    const resourcePage = 'customer-personalize/graphql';
    const body = {
        // This query can have other fields as well in the response such as { indivId, emailId, brand, lastModifiedTime, billingEmailId, phone, salesForceUserId, timeCreated }
        query: `{customerIdentity(browserUUID:"${browserUUID}") { emailId }}`,
        variables: {},
    };

    try {
        const usersReponse = await restClient.postFacade(wcEnv, resourcePage, token, body);
        return usersReponse?.data?.data?.customerIdentity?.emailId || '';
    } catch (err) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: err,
            message: 'fetchUserEmailbyBrowserUUID: Error while fetching user details.',
        });
        return '';
    }
};

export default {};
